import { MutableState } from '../State';
import { addAccessoryItem } from '../accessory/accessory.modifiers';
import { Feature } from '../analytics';
import { AccessoryItemID } from '../data/AccessoryItems.schema';
import { AccessoryTierID } from '../data/AccessoryTiers.schema';
import { DecorationItemID } from '../data/DecorationItems.schema';
import { DecorationTierID } from '../data/DecorationTiers.schema';
import { addDecorationItem } from '../decoration/decoration.modifiers';
import * as Inventory from '../inventory';
import { CurrencyReplicantAPI } from '../inventory/inventory.utils';
import { setPromoSeen } from '../promo/promo.modifiers';
import { assertNever } from '../utils';
import { gachaHasTag, getGachaCurrency, getGachaPrice } from './gacha.getters';
import { GachaID, GachaItem } from './gacha.ruleset';

/**
 * Consume gacha rewards.
 * @param state
 */
export function consumeGachaRewards(
  state: MutableState,
  items: GachaItem[],
  now: number,
): void {
  items.forEach((item) => {
    switch (item.type) {
      case 'decoration':
        {
          const { tierId } = item;
          addDecorationItem(
            state,
            item.id as DecorationItemID,
            tierId as DecorationTierID,
            now,
          );
        }
        break;
      case 'accessory':
        {
          const { tierId } = item;
          addAccessoryItem(
            state,
            item.id as AccessoryItemID,
            tierId as AccessoryTierID,
            now,
          );
        }
        break;
      default:
        assertNever(item);
    }
  });
}

/**
 * Consume gacha currency.
 * @param state
 * @param gachaId
 * @param api
 * @returns
 */
export function consumeGachaCurrency(
  state: MutableState,
  gachaId: GachaID,
  api: CurrencyReplicantAPI,
): void {
  // Get previous currencies.
  const now = api.date.now();

  // Get price of gacha.
  const price = getGachaPrice(state, gachaId);
  const currency = getGachaCurrency(gachaId);

  switch (currency) {
    case 'gems':
      // Consume gems.
      Inventory.modifiers.consumeGems(
        state,
        price,
        {
          feature: Feature.GACHA._,
          $subFeature: gachaId,
        },
        api,
      );
      break;
    // Consume tickets.
    case 'bronze_ticket':
    case 'silver_ticket':
      break;
    default:
      assertNever(currency);
  }

  // Mark promo as seen. Since the discount is only available once per day.
  // The 1-spin and 10 spin discount are now independent, so if you purchase the 1-spin,
  //  the 10-spin discount should remain available.
  if (gachaHasTag(state, gachaId, 'discount')) {
    if (gachaHasTag(state, gachaId, '10-spin')) {
      setPromoSeen(state, 'dailyGachaMultiSpin', now);
    } else {
      setPromoSeen(state, 'dailyGacha', now);
    }
  }
}
